import React from "react";
import Landing from "./Landing";
import { v4 as uuidv4 } from "uuid";
import * as CONSTANTS from "../../utilities/Constants";
import SidebarLayout from "../shared/SidebarLayout";
import SidebarTitle from "../shared/SidebarTitle";
import { Checkbox, Input } from "@abb/abb-common-ux-react";
import { Translation } from "react-i18next";
import TrendFormStore from "../../flux/stores/trend/ListStore";
import TrendValuesFormStore from "../../flux/stores/trend/trendPropertyValues";
import TrendActions from "../../flux/actions/TrendActions";
import gradeListStore from "../../flux/stores/grade/ListStore";
import { IGradeViewData } from "../../models/grade/GradeViewData";
import triggerNotifications from "../../utilities/TriggerNotifications";
import dateRangeStore from "../../flux/stores/trend/DateRange";
import moment from "moment";
import { ITrendViewData } from "../../models/trends/TrendViewData";
import loadingActions from "../../flux/actions/LoadingActions";
import thresholdSettingStore from "../../flux/stores/settings/ThresholdSettingStore";
import settingsActions from "../../flux/actions/SettingsAction";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";
import IActionHeaderFormData from "../../models/shared/ActionHeaderData";
import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import { Icon, Tooltip, WithTooltip } from "@abb/abb-common-ux-react";
import { constant } from "lodash";
import DateFormatting from "../../utilities/DateFormat";
import i18next from "i18next";
import sourceActions from "../../flux/actions/SourceActions";
import sourceListStore from "../../flux/stores/source/ListStore";
import { ISourceViewData } from "../../models/source/SourceViewData";

interface IIndexState {
  gradeList: any[];
  productList: any[];
  sampleList: any[];
  sourceDropdownList: any[];
  trendPropertyDetails: any[];
  selectedDateRange: any[];
  selectFromDate: any;
  selectToDate: any;
  selectedGrade: any[];
  selectedProduct: any[];
  selectedSample: any[];
  selectedSource: any[];
  isFullSidebarVisible: boolean;
  searchValue: string;
  properties: any[];
  propertiesValues: any[];
  propertyVal: any[];
  isSelected: any[];
  dataId: any[];
  listData: any;
  sample: any[];
  data: any[];
  tabledata: any[];
  thresholdSettings: IThresholdSettings[];
  isLoading: boolean;
  loadingProperties: boolean;
}

export default class Trends extends React.Component<
  { location: any },
  IIndexState
> {
  private = CONSTANTS.MODULE_TRENDS;
  private _mount: boolean;
  private _id: string;
  private _messages: string[];
  private _propertyList: any[];
  private _propertyListValues: any[];
  private _datetimeFormat = "YYYY-MM-DD HH:mm:ss";
  private _ALL = "ALL";
  private _thresholdSettings: any;

  _gradeDropdownList: IGradeViewData[] = [];
  _trendDropdownSampleList: ITrendViewData[] = [];
  _trendDropdownProductList: ITrendViewData[] = [];
  _trendDropdownGradeList: ITrendViewData[] = [];
  _trendDropdownSourceList: ITrendViewData[] = [];
  private _sourceList: any[] = [];
  _trendPropertyDetails: any[] = [];
  private _directions: any[] = [];
  private _unselected: any[] = [];
  private _hasMore: boolean = true;
  private _defaultDrpOption = [{ value: this._ALL, label: this._ALL }];

  constructor(props: { location: any }) {
    super(props);
    const searchValue = this.props.location.state?.searchValue || "";
    this.state = {
      gradeList: [],
      productList: [],
      sampleList: [],
      sourceDropdownList: [],
      trendPropertyDetails: [],
      selectedDateRange: [CONSTANTS.DATE_RANGES[0]],
      selectFromDate: moment().subtract(1, "d").format(this._datetimeFormat),
      selectToDate: moment().format(this._datetimeFormat),
      selectedGrade: this._defaultDrpOption,
      selectedProduct: this._defaultDrpOption,
      selectedSample: this._defaultDrpOption,
      selectedSource: this._defaultDrpOption,
      properties: [],
      isFullSidebarVisible: true,
      searchValue,
      propertiesValues: [],
      propertyVal: [],
      isSelected: [],
      dataId: [],
      listData: [],
      sample: [],
      data: [],
      tabledata: [],
      thresholdSettings: [],
      isLoading: false,
      loadingProperties: false
    };
  }

  componentDidMount() {
    this._mount = true;
    /// Remove all header options
    actionHeaderActions
      .common({
        moduleName: CONSTANTS.MODULE_SETTINGS,
        createData: {},
      })
      .then();
    loadingActions.setLoading(false);

    sourceListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      state.sourceDataList?.result.forEach((source: ISourceViewData) => {
        const data = {
          name: source.name,
          id: source.id,
        };

        this._sourceList.push(data);
      });
    });

    // sourceActions
    //   .getAll(
    //     1,
    //     CONSTANTS.PAGE_SIZE_ALL,
    //     CONSTANTS.SORT_CREATEDON,
    //     CONSTANTS.SORT_ORDER,
    //     ""
    //   )
    //   .then(() => {
    //     this.setState({
    //       sourceDropdownList: this._sourceList,
    //     });
    //   });

    gradeListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      const data = state.gradeDataList as IGradeViewData[];
      this.setState({
        selectedGrade: [data[0]],
        gradeList: data,
      });
    });

    dateRangeStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._trendDropdownSampleList = state.trendDataList.data.sampleDetails;
      this._trendDropdownProductList = state.trendDataList.data.productDetails;
      this._trendDropdownGradeList = state.trendDataList.data.gradeDetails;
      this._trendDropdownSourceList = state.trendDataList.data.sourceDetails;
    });

    TrendFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._id = state.trendId;
        this._messages = state.message;
        if (
          state.trendId.currentPage === state.trendId.totalPages ||
          state.trendId.totalRecords === 0
        ) {
          this._hasMore = false;
        } else {
          this._hasMore = true;
        }
        const data = state.trendId.contents as any[];
        const items: any[] = [];
        data.forEach((element) => {
          items.push(element.id, element.name);
        });
      }
      this._propertyList = state.trendId.contents;
      this._propertyList.forEach((element) => {
        element.selected = false;
      });
    });
    TrendValuesFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._id = state.trendIdValue;
        this._messages = state.message;
      }
      this._propertyListValues = state.trendIdValue.data;
    });
    this.onDateRangeChange([CONSTANTS.DATE_RANGES[0]]);
    thresholdSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._thresholdSettings = state.data;
      }
    });
    this.getThresholdValues();
  }
  private getThresholdValues = () => {
    settingsActions
      .getThresholdReport()
      .then(() => {
        this.setState({
          thresholdSettings: this._thresholdSettings,
        });
      })
      .catch((e) => {
        triggerNotifications.error(e);
      });
  };

  private reSet = () => {
    this.setState({
      selectedGrade: this._defaultDrpOption,
      selectedProduct: this._defaultDrpOption,
      selectedSample: this._defaultDrpOption,
      selectedSource: this._defaultDrpOption,
      properties: [],
      propertiesValues: [],
      isSelected: [],
      tabledata: [],
    });
    this._directions = [];
  };
  private GetProperties = () => {
    const payload: any = this.getPropertiesPayload(
      "Name",
      CONSTANTS.SORT_ORDER,
      ""
    );
    loadingActions.setLoading(true);
    this.setState({loadingProperties: true});
    TrendActions.GetTrendsPropertiesDetails(payload, uuidv4())
      .then(() => {
        loadingActions.setLoading(false);
        this.setState(
          {
            properties: this._propertyList,
            loadingProperties: false
          },
          () => {
            this.setSelectedProps(this.state.properties);
          }
        );
      })
      .catch(() => {
        loadingActions.setLoading(false);
        this.setState({loadingProperties: false});
      });
  };

  private getPropertiesPayload = (
    sort: string,
    order: string,
    filter: string
  ) => {
    let samples = [];
    samples =
      this.state.selectedSample[0]?.value === this._defaultDrpOption[0]?.value
        ? this.state.selectedSource[0].value !==
          this._defaultDrpOption[0]?.value
          ? this.state.selectedGrade[0]?.value ===
            this._defaultDrpOption[0]?.value
            ? this.state.selectedProduct[0]?.value ===
              this._defaultDrpOption[0]?.value
              ? this.state.sampleList
                  ?.filter(({ sourceId }) =>
                    this.state.selectedSource.some(
                      (source) => source.value === sourceId
                    )
                  )
                  .map(({ id }) => id)
              : this.state.sampleList
                  ?.filter(({ sourceId }) =>
                    this.state.selectedSource.some(
                      (source) => source.value === sourceId
                    )
                  )
                  ?.filter(({ productId }) =>
                    this.state.selectedProduct.some(
                      (product) => product.value === productId
                    )
                  )
                  .map(({ id }) => id)
            : this.state.selectedProduct[0]?.value ===
              this._defaultDrpOption[0]?.value
            ? this.state.sampleList
                ?.filter(({ sourceId }) =>
                  this.state.selectedSource.some(
                    (source) => source.value === sourceId
                  )
                )
                ?.filter(({ gradeId }) =>
                  this.state.selectedGrade.some(
                    (grade) => grade.value === gradeId
                  )
                )
                .map(({ id }) => id)
            : this.state.sampleList
                ?.filter(({ sourceId }) =>
                  this.state.selectedSource.some(
                    (source) => source.value === sourceId
                  )
                )
                ?.filter(({ gradeId }) =>
                  this.state.selectedGrade.some(
                    (grade) => grade.value === gradeId
                  )
                )
                ?.filter(({ productId }) =>
                  this.state.selectedProduct.some(
                    (product) => product.value === productId
                  )
                )
                .map(({ id }) => id)
          : this.state.selectedGrade[0]?.value ===
            this._defaultDrpOption[0]?.value
          ? this.state.selectedProduct[0]?.value ===
            this._defaultDrpOption[0]?.value
            ? this.state.sampleList.map(({ id }) => id)
            : this.state.sampleList
                ?.filter(({ productId }) =>
                  this.state.selectedProduct.some(
                    (product) => product.value === productId
                  )
                )
                .map(({ id }) => id)
          : this.state.selectedProduct[0]?.value ===
            this._defaultDrpOption[0]?.value
          ? this.state.sampleList
              ?.filter(({ gradeId }) =>
                this.state.selectedGrade.some(
                  (grade) => grade.value === gradeId
                )
              )
              .map(({ id }) => id)
          : this.state.sampleList
              ?.filter(({ gradeId }) =>
                this.state.selectedGrade.some(
                  (grade) => grade.value === gradeId
                )
              )
              ?.filter(({ productId }) =>
                this.state.selectedProduct.some(
                  (product) => product.value === productId
                )
              )
              .map(({ id }) => id)
        : this.state.selectedSample?.map(({ value }) => value);
    return {
      gradeIdCollection:
        this.state.selectedGrade[0]?.value === this._defaultDrpOption[0]?.value
          ? this.state.selectedSource[0].value !==
            this._defaultDrpOption[0]?.value
            ? this.state.selectedSample[0].value !==
              this._defaultDrpOption[0]?.value
              ? this.state.gradeList
                  ?.filter(({ id }) =>
                    this.state.sampleList
                      ?.filter(({ sourceId }) =>
                        this.state.selectedSource.some(
                          (source) => source.value === sourceId
                        )
                      )
                      ?.filter(({ id }) =>
                        this.state.selectedSample.some(
                          (sample) => sample.value === id
                        )
                      )
                      .some(
                        (sample) =>
                          (sample?.gradeId
                            ? sample?.gradeId
                            : sample?.product?.grade?.id) === id
                      )
                  )
                  .map(({ id }) => id)
              : this.state.gradeList
                  ?.filter(({ id }) =>
                    this.state.sampleList
                      ?.filter(({ sourceId }) =>
                        this.state.selectedSource.some(
                          (source) => source.value === sourceId
                        )
                      )
                      .some(
                        (sample) =>
                          (sample?.gradeId
                            ? sample?.gradeId
                            : sample?.product?.grade?.id) === id
                      )
                  )
                  .map(({ id }) => id)
            : this.state.selectedSample[0].value !==
              this._defaultDrpOption[0]?.value
            ? this.state.gradeList
                ?.filter(({ id }) =>
                  this.state.sampleList
                    ?.filter(({ id }) =>
                      this.state.selectedSample.some(
                        (sample) => sample.value === id
                      )
                    )
                    .some(
                      (sample) =>
                        (sample?.gradeId
                          ? sample?.gradeId
                          : sample?.product?.grade?.id) === id
                    )
                )
                .map(({ id }) => id)
            : this.state.gradeList
                ?.filter(({ id }) =>
                  this.state.sampleList.some(
                    (sample) =>
                      (sample?.gradeId
                        ? sample?.gradeId
                        : sample?.product?.grade?.id) === id
                  )
                )
                .map(({ id }) => id)
          : this.state.selectedGrade?.map(({ value }) => value),
      productIdCollection:
        this.state.selectedProduct[0]?.value ===
        this._defaultDrpOption[0]?.value
          ? this.state.selectedSource[0].value !==
            this._defaultDrpOption[0]?.value
            ? this.state.selectedGrade[0]?.value ===
              this._defaultDrpOption[0]?.value
              ? this.state.selectedSample[0]?.value !==
                this._defaultDrpOption[0]?.value
                ? this.state.productList
                    ?.filter(({ id }) =>
                      this.state.sampleList
                        ?.filter(({ sourceId }) =>
                          this.state.selectedSource.some(
                            (source) => source.value === sourceId
                          )
                        )
                        ?.filter(({ id }) =>
                          this.state.selectedSample.some(
                            (sample) => sample.value === id
                          )
                        )
                        .some((sample) => sample?.productId === id)
                    )
                    .map(({ id }) => id)
                : this.state.productList
                    ?.filter(({ id }) =>
                      this.state.sampleList
                        ?.filter(({ sourceId }) =>
                          this.state.selectedSource.some(
                            (source) => source.value === sourceId
                          )
                        )
                        .some((sample) => sample?.productId === id)
                    )
                    .map(({ id }) => id)
              : this.state.selectedSample[0]?.value !==
                this._defaultDrpOption[0]?.value
              ? this.state.productList
                  ?.filter(({ id }) =>
                    this.state.sampleList
                      ?.filter(({ sourceId }) =>
                        this.state.selectedSource.some(
                          (source) => source.value === sourceId
                        )
                      )
                      ?.filter(({ id }) =>
                        this.state.selectedSample.some(
                          (sample) => sample.value === id
                        )
                      )
                      ?.filter(({ gradeId }) =>
                        this.state.selectedGrade.some(
                          (grade) => grade.value === gradeId
                        )
                      )
                      .some((sample) => sample?.productId === id)
                  )
                  .map(({ id }) => id)
              : this.state.productList
                  ?.filter(({ id }) =>
                    this.state.sampleList
                      ?.filter(({ sourceId }) =>
                        this.state.selectedSource.some(
                          (source) => source.value === sourceId
                        )
                      )
                      ?.filter(({ gradeId }) =>
                        this.state.selectedGrade.some(
                          (grade) => grade.value === gradeId
                        )
                      )
                      .some((sample) => sample?.productId === id)
                  )
                  .map(({ id }) => id)
            : this.state.selectedGrade[0]?.value ===
              this._defaultDrpOption[0]?.value
            ? this.state.selectedSample[0]?.value !==
              this._defaultDrpOption[0]?.value
              ? this.state.productList
                  ?.filter(({ id }) =>
                    this.state.sampleList
                      ?.filter(({ id }) =>
                        this.state.selectedSample.some(
                          (sample) => sample.value === id
                        )
                      )
                      .some((sample) => sample?.productId === id)
                  )
                  .map(({ id }) => id)
              : this.state.productList
                  ?.filter(({ id }) =>
                    this.state.sampleList.some(
                      (sample) => sample?.productId === id
                    )
                  )
                  .map(({ id }) => id)
            : this.state.selectedSample[0]?.value !==
              this._defaultDrpOption[0]?.value
            ? this.state.productList
                ?.filter(({ id }) =>
                  this.state.sampleList
                    ?.filter(({ id }) =>
                      this.state.selectedSample.some(
                        (sample) => sample.value === id
                      )
                    )
                    ?.filter(({ gradeId }) =>
                      this.state.selectedGrade.some(
                        (grade) => grade.value === gradeId
                      )
                    )
                    .some((sample) => sample?.productId === id)
                )
                .map(({ id }) => id)
            : this.state.productList
                ?.filter(({ id }) =>
                  this.state.sampleList
                    ?.filter(({ gradeId }) =>
                      this.state.selectedGrade.some(
                        (grade) => grade.value === gradeId
                      )
                    )
                    .some((sample) => sample?.productId === id)
                )
                .map(({ id }) => id)
          : this.state.selectedProduct?.map(({ value }) => value),
      sampleIdCollection: samples,
      sourceIdCollection:
        this.state.selectedSource[0]?.value === this._defaultDrpOption[0]?.value
          ? this.state.sourceDropdownList?.map(({ id }) => id)
          : this.state.selectedSource?.map(({ value }) => value),
      sort: sort,
      order: order,
      filter: filter,
      page: 1,
      pageSize: CONSTANTS.PAGE_SIZE_ALL,
    };
  };
  private fetchDateRange = (dateFrom: any, dateTo: any) => {
    loadingActions.setLoading(true);
    TrendActions.getDateRange(dateFrom, dateTo, uuidv4())
      .then(() => {
        loadingActions.setLoading(false);
        const sampleList: any[] = [];
        const gradeList: any[] = [];
        const productList: any[] = [];
        const sourceDropdownList: any[] = [];

        this._trendDropdownSampleList?.forEach((element: ITrendViewData) => {
          sampleList.push({
            name: element?.name,
            id: element?.id,
            productId: element?.product?.id,
            gradeId: element?.grade
              ? element?.grade?.id
              : (element?.gradeId ? element?.gradeId :  element?.product?.grade?.id),
            sourceId: element?.sourceId,
          });
        });
        this._trendDropdownGradeList?.map((i: any) => {
          gradeList.push({
            name: i.name,
            id: i.id,
          });
        });
        this._trendDropdownSourceList?.map((i: any) => {
          sourceDropdownList.push({
            name: i.name,
            id: i.id,
          });
        });
        this._trendDropdownProductList.map((i: any) => {
          if (!productList.includes(i)) {
            productList.push({
              name: i.name,
              id: i.id,
              gradeId: i?.gradeId,
            });
          }
        });

        this.setState(
          {
            sampleList,
            gradeList,
            productList,
            sourceDropdownList,
          },
          () => {
            this.GetProperties();
          }
        );
      })
      .catch((error) => {
        loadingActions.setLoading(false);
        triggerNotifications.errors(error.message, error.data);
      });
  };
  componentDidUpdate(prevProps: any, prevState: any) {
    if (
      prevState.selectFromDate !== this.state.selectFromDate ||
      prevState.selectToDate !== this.state.selectToDate
    ) {
      this.onDateRangeChange(this.state.selectedDateRange);
    }
  }

  private onDateRangeChange = (val: any) => {
    this.setState({
      selectedDateRange: val,
      isSelected: [],
      tabledata: [],
    });

    let fromDate: any = "",
      toDate: any = "";
    let selectedDate = val[0]?.value;
    toDate = moment().format(this._datetimeFormat);
    switch (selectedDate) {
      case 1:
        fromDate = moment().subtract(1, "d").format(this._datetimeFormat);
        break;
      case 2:
        fromDate = moment().subtract(7, "d").format(this._datetimeFormat);
        break;
      case 3:
        fromDate = moment().subtract(30, "d").format(this._datetimeFormat);
        break;
      case 4:
        fromDate = this.state.selectFromDate;
        toDate = this.state.selectToDate;
        break;
      default:
        fromDate = moment().subtract(1, "d").format(this._datetimeFormat);
        break;
    }
    if (moment(fromDate) >= moment(toDate)) {
      triggerNotifications.errors([CONSTANTS.FROM_GRATER_TO]).then();
    } else {
      this.setState({
        selectFromDate: fromDate,
        selectToDate: toDate,
        searchValue: "",
      }, () => {
        this.fetchDateRange(
          moment.utc(new Date(this.state.selectFromDate)).format(), // new Date(fromDate).toUTCString(),
          moment.utc(new Date(this.state.selectToDate)).format() //new Date(toDate).toUTCString()
        );
        this.reSet();
      });
    }
  };

  private GradeChangeHandler = (val: any) => {
    this.setState(
      {
        selectedProduct: this._defaultDrpOption,
        selectedSample: this._defaultDrpOption,
        isSelected: [],
        tabledata: [],
      },
      () => {
        this._directions = [];
        if (val.length === 0) {
          val = this._defaultDrpOption;
        }
        if (
          val.find(
            (x: { value: string }) =>
              x.value !== this._defaultDrpOption[0].value
          )
        ) {
          const inx = val.findIndex(
            (x: { value: string }) =>
              x.value === this._defaultDrpOption[0].value
          );
          if (inx !== -1) {
            val.splice(inx, 1);
          }
        }
        val.forEach((v: any) => {
          val =
            val.length > 1 && val[0].label === "ALL" && val[0].value === "ALL"
              ? val.slice(1)
              : val;

          this.setState(
            {
              selectedGrade: val,
              searchValue: "",
            },
            () => {
              this.GetProperties();
            }
          );
        });
      }
    );
  };

  private SourceChangeHandler = (val: any) => {
    this.setState(
      {
        selectedSample: this._defaultDrpOption,
        selectedGrade: this._defaultDrpOption,
        selectedProduct: this._defaultDrpOption,
        isSelected: [],
        tabledata: [],
      },
      () => {
        this._directions = [];
        if (val.length === 0) {
          val = this._defaultDrpOption;
        }
        if (
          val.find(
            (x: { value: string }) =>
              x.value !== this._defaultDrpOption[0].value
          )
        ) {
          const inx = val.findIndex(
            (x: { value: string }) =>
              x.value === this._defaultDrpOption[0].value
          );
          if (inx !== -1) {
            val.splice(inx, 1);
          }
        }
        val.forEach((v: any) => {
          this.setState(
            {
              selectedSource: val,
              searchValue: "",
            },
            () => {
              this.GetProperties();
            }
          );
        });
      }
    );
  };

  private ProductChangeHandler = (val: any) => {
    this.setState(
      {
        selectedSample: this._defaultDrpOption,
        isSelected: [],
        tabledata: [],
      },
      () => {
        this._directions = [];
        if (val.length === 0) {
          val = this._defaultDrpOption;
        }
        if (
          val.find(
            (x: { value: string }) =>
              x.value !== this._defaultDrpOption[0].value
          )
        ) {
          const inx = val.findIndex(
            (x: { value: string }) =>
              x.value === this._defaultDrpOption[0].value
          );
          if (inx !== -1) {
            val.splice(inx, 1);
          }
        }
        val.forEach((v: any) => {
          this.setState(
            {
              selectedProduct: val,
              searchValue: "",
            },
            () => {
              this.GetProperties();
            }
          );
        });
      }
    );
  };

  private SampleChangeHandler = (val: any) => {
    this.setState({
      isSelected: [],
      tabledata: [],
    });
    this._directions = [];
    if (val.length === 0) {
      val = this._defaultDrpOption;
    }
    if (
      val.find(
        (x: { value: string }) => x.value !== this._defaultDrpOption[0].value
      )
    ) {
      const inx = val.findIndex(
        (x: { value: string }) => x.value === this._defaultDrpOption[0].value
      );
      if (inx !== -1) {
        val.splice(inx, 1);
      }
    }
    val.forEach((v: any) => {
      this.setState(
        {
          selectedSample: val,
          searchValue: "",
        },
        () => {
          this.GetProperties();
          //this.propertyValues(val);
        }
      );
    });
  };
  private propertyValues = (value: any) => {    
    const payload: any = {
      ids: this.state.isSelected,
      samples:
        this.state.selectedSample[0]?.value === this._defaultDrpOption[0]?.value
          ? this.state.selectedSource[0].value !==
            this._defaultDrpOption[0]?.value
            ? this.state.selectedGrade[0]?.value ===
              this._defaultDrpOption[0]?.value
              ? this.state.selectedProduct[0]?.value ===
                this._defaultDrpOption[0]?.value
                ? this.state.sampleList
                    ?.filter(({ sourceId }) =>
                      this.state.selectedSource.some(
                        (source) => source.value === sourceId
                      )
                    )
                    .map(({ id }) => id)
                : this.state.sampleList
                    ?.filter(({ sourceId }) =>
                      this.state.selectedSource.some(
                        (source) => source.value === sourceId
                      )
                    )
                    ?.filter(({ productId }) =>
                      this.state.selectedProduct.some(
                        (product) => product.value === productId
                      )
                    )
                    .map(({ id }) => id)
              : this.state.selectedProduct[0]?.value ===
                this._defaultDrpOption[0]?.value
              ? this.state.sampleList
                  ?.filter(({ sourceId }) =>
                    this.state.selectedSource.some(
                      (source) => source.value === sourceId
                    )
                  )
                  ?.filter(({ gradeId }) =>
                    this.state.selectedGrade.some(
                      (grade) => grade.value === gradeId
                    )
                  )
                  .map(({ id }) => id)
              : this.state.sampleList
                  ?.filter(({ sourceId }) =>
                    this.state.selectedSource.some(
                      (source) => source.value === sourceId
                    )
                  )
                  ?.filter(({ gradeId }) =>
                    this.state.selectedGrade.some(
                      (grade) => grade.value === gradeId
                    )
                  )
                  ?.filter(({ productId }) =>
                    this.state.selectedProduct.some(
                      (product) => product.value === productId
                    )
                  )
                  .map(({ id }) => id)
            : this.state.selectedGrade[0]?.value ===
              this._defaultDrpOption[0]?.value
            ? this.state.selectedProduct[0]?.value ===
              this._defaultDrpOption[0]?.value
              ? this.state.sampleList.map(({ id }) => id)
              : this.state.sampleList
                  ?.filter(({ productId }) =>
                    this.state.selectedProduct.some(
                      (product) => product.value === productId
                    )
                  )
                  .map(({ id }) => id)
            : this.state.selectedProduct[0]?.value ===
              this._defaultDrpOption[0]?.value
            ? this.state.sampleList
                ?.filter(({ gradeId }) =>
                  this.state.selectedGrade.some(
                    (grade) => grade.value === gradeId
                  )
                )
                .map(({ id }) => id)
            : this.state.sampleList
                ?.filter(({ gradeId }) =>
                  this.state.selectedGrade.some(
                    (grade) => grade.value === gradeId
                  )
                )
                ?.filter(({ productId }) =>
                  this.state.selectedProduct.some(
                    (product) => product.value === productId
                  )
                )
                .map(({ id }) => id)
          : this.state.selectedSample?.map(({ value }) => value),
      dateRange: {
        from: new Date(this.state.selectFromDate).toUTCString(),
        to: new Date(this.state.selectToDate).toUTCString(),
      },
      grades:
        this.state.selectedGrade[0]?.value === this._defaultDrpOption[0]?.value
          ? this.state.selectedSource[0].value !==
            this._defaultDrpOption[0]?.value
            ? this.state.selectedSample[0].value !==
              this._defaultDrpOption[0]?.value
              ? this.state.gradeList
                  ?.filter(({ id }) =>
                    this.state.sampleList
                      ?.filter(({ sourceId }) =>
                        this.state.selectedSource.some(
                          (source) => source.value === sourceId
                        )
                      )
                      ?.filter(({ id }) =>
                        this.state.selectedSample.some(
                          (sample) => sample.value === id
                        )
                      )
                      .some(
                        (sample) =>
                          (sample?.gradeId
                            ? sample?.gradeId
                            : sample?.product?.grade?.id) === id
                      )
                  )
                  .map(({ id }) => id)
              : this.state.gradeList
                  ?.filter(({ id }) =>
                    this.state.sampleList
                      ?.filter(({ sourceId }) =>
                        this.state.selectedSource.some(
                          (source) => source.value === sourceId
                        )
                      )
                      .some(
                        (sample) =>
                          (sample?.gradeId
                            ? sample?.gradeId
                            : sample?.product?.grade?.id) === id
                      )
                  )
                  .map(({ id }) => id)
            : this.state.selectedSample[0].value !==
              this._defaultDrpOption[0]?.value
            ? this.state.gradeList
                ?.filter(({ id }) =>
                  this.state.sampleList
                    ?.filter(({ id }) =>
                      this.state.selectedSample.some(
                        (sample) => sample.value === id
                      )
                    )
                    .some(
                      (sample) =>
                        (sample?.gradeId
                          ? sample?.gradeId
                          : sample?.product?.grade?.id) === id
                    )
                )
                .map(({ id }) => id)
            : this.state.gradeList
                ?.filter(({ id }) =>
                  this.state.sampleList.some(
                    (sample) =>
                      (sample?.gradeId
                        ? sample?.gradeId
                        : sample?.product?.grade?.id) === id
                  )
                )
                .map(({ id }) => id)
          : this.state.selectedGrade?.map(({ value }) => value),
      products:
        this.state.selectedProduct[0]?.value ===
        this._defaultDrpOption[0]?.value
          ? this.state.selectedSource[0].value !==
            this._defaultDrpOption[0]?.value
            ? this.state.selectedGrade[0]?.value ===
              this._defaultDrpOption[0]?.value
              ? this.state.selectedSample[0]?.value !==
                this._defaultDrpOption[0]?.value
                ? this.state.productList
                    ?.filter(({ id }) =>
                      this.state.sampleList
                        ?.filter(({ sourceId }) =>
                          this.state.selectedSource.some(
                            (source) => source.value === sourceId
                          )
                        )
                        ?.filter(({ id }) =>
                          this.state.selectedSample.some(
                            (sample) => sample.value === id
                          )
                        )
                        .some((sample) => sample?.productId === id)
                    )
                    .map(({ id }) => id)
                : this.state.productList
                    ?.filter(({ id }) =>
                      this.state.sampleList
                        ?.filter(({ sourceId }) =>
                          this.state.selectedSource.some(
                            (source) => source.value === sourceId
                          )
                        )
                        .some((sample) => sample?.productId === id)
                    )
                    .map(({ id }) => id)
              : this.state.selectedSample[0]?.value !==
                this._defaultDrpOption[0]?.value
              ? this.state.productList
                  ?.filter(({ id }) =>
                    this.state.sampleList
                      ?.filter(({ sourceId }) =>
                        this.state.selectedSource.some(
                          (source) => source.value === sourceId
                        )
                      )
                      ?.filter(({ id }) =>
                        this.state.selectedSample.some(
                          (sample) => sample.value === id
                        )
                      )
                      ?.filter(({ gradeId }) =>
                        this.state.selectedGrade.some(
                          (grade) => grade.value === gradeId
                        )
                      )
                      .some((sample) => sample?.productId === id)
                  )
                  .map(({ id }) => id)
              : this.state.productList
                  ?.filter(({ id }) =>
                    this.state.sampleList
                      ?.filter(({ sourceId }) =>
                        this.state.selectedSource.some(
                          (source) => source.value === sourceId
                        )
                      )
                      ?.filter(({ gradeId }) =>
                        this.state.selectedGrade.some(
                          (grade) => grade.value === gradeId
                        )
                      )
                      .some((sample) => sample?.productId === id)
                  )
                  .map(({ id }) => id)
            : this.state.selectedGrade[0]?.value ===
              this._defaultDrpOption[0]?.value
            ? this.state.selectedSample[0]?.value !==
              this._defaultDrpOption[0]?.value
              ? this.state.productList
                  ?.filter(({ id }) =>
                    this.state.sampleList
                      ?.filter(({ id }) =>
                        this.state.selectedSample.some(
                          (sample) => sample.value === id
                        )
                      )
                      .some((sample) => sample?.productId === id)
                  )
                  .map(({ id }) => id)
              : this.state.productList
                  ?.filter(({ id }) =>
                    this.state.sampleList.some(
                      (sample) => sample?.productId === id
                    )
                  )
                  .map(({ id }) => id)
            : this.state.selectedSample[0]?.value !==
              this._defaultDrpOption[0]?.value
            ? this.state.productList
                ?.filter(({ id }) =>
                  this.state.sampleList
                    ?.filter(({ id }) =>
                      this.state.selectedSample.some(
                        (sample) => sample.value === id
                      )
                    )
                    ?.filter(({ gradeId }) =>
                      this.state.selectedGrade.some(
                        (grade) => grade.value === gradeId
                      )
                    )
                    .some((sample) => sample?.productId === id)
                )
                .map(({ id }) => id)
            : this.state.productList
                ?.filter(({ id }) =>
                  this.state.sampleList
                    ?.filter(({ gradeId }) =>
                      this.state.selectedGrade.some(
                        (grade) => grade.value === gradeId
                      )
                    )
                    .some((sample) => sample?.productId === id)
                )
                .map(({ id }) => id)
          : this.state.selectedProduct?.map(({ value }) => value),
      sources:
        this.state.selectedSource[0]?.value === this._defaultDrpOption[0]?.value
          ? this.state.selectedSample[0]?.value !==
            this._defaultDrpOption[0]?.value 
            ? this.state.sourceDropdownList
              ?.filter(({ id }) =>
                this.state.sampleList
                ?.filter(({ id }) =>
                  this.state.selectedSample.some(
                    (sample) => sample.value === id
                  )
                )           
                .some((sample) => sample?.sourceId === id)
              ).map(({ id }) => id)
            : this.state.sourceDropdownList?.map(({ id }) => id)
          : this.state.selectedSource?.map(({ value }) => value),
    };
    loadingActions.setLoading(true);
    this.setState({isLoading: true})
    //this._directions = [];  
    TrendActions.PostPropertyValues(payload, uuidv4())
      .then(() => {
        loadingActions.setLoading(false);
        this.setState({isLoading: false})
        this.setState({
          propertiesValues: this._propertyListValues,
        });
        
        const allSample: any[] = [];   
        let alltrenddata: any[] = [];     
        this._propertyListValues.forEach((i: any) => {   
          const sample: any[] = [];   
          i.sampleDetail.map((s: any) => {
            if (!sample.some((item: any) => item.sampleId === s.id) && s.propertiesValues.avgMeans != null ) {
              if (!allSample.some(item => item.sampleId === s.id && item.propertyName === i.name)) {
                {
                  sample.push({
                    xValue: moment(s.sampleDate + "z").toDate(),
                    value: +s.propertiesValues.avgMeans,
                    sampleName: s.name,
                    sampleId: s.id,
                    sampleDate: s.sampleDate
                  });
                  
                  allSample.push({
                    xValue: moment(s.sampleDate + "z").toDate(),
                    value: +s.propertiesValues.avgMeans,
                    sampleName: s.name,
                    sampleId: s.id,
                    sampleDate: s.sampleDate,
                    propertyName: i.name
                  });   
                } 
              }                       
          }
          });

          sample.sort((a: any, b: any) => {
            return new Date(a.xValue).valueOf() - new Date(b.xValue).valueOf();
          });        
                   
            alltrenddata.push({
              id: i.propertyId,
              name: i.name,
              minValue: i.meanMin,
              maxValue: i.meanMax,
              mean: i.meanAvg,
              unit: i.unit,
              deviation: i.standardDeviationAvg,
              propertyId: value,
              data: sample,
              color: this.getRandomColor(),
              decimals: i.decimals,
              directionId: i.directionId,
              code: i.code,              
              alarmLow1: i.alarmLow1,
              alarmLow2: i.alarmLow2,
              alarmHigh1: i.alarmHigh1,
              alarmHigh2: i.alarmHigh2,
              rejectLow: i.rejectLow,
              rejectHigh: i.rejectHigh,
              ok: i.ok,
              alarmCount: i.alarmCount,
              reject: i.reject,
            });                     
        });
        
        if(this._propertyListValues.length == alltrenddata.length)
          {
            this._directions = alltrenddata;
            this.setState({              
              tabledata: this._directions,
            });
          }       
      })
      .catch((error) => {
        loadingActions.setLoading(false);
        this.setState({isLoading: false})
      });
  };

  public onsearch = (value: any) => {
    const payload: any = this.getPropertiesPayload(
      "Name",
      CONSTANTS.SORT_ORDER,
      "&Name:" + value
    );
    if (value.length >= CONSTANTS.SEARCH_LENGTH || value.length === 0) {
      loadingActions.setLoading(true);
      TrendActions.GetTrendsPropertiesDetails(payload, uuidv4())
        .then(() => {
          loadingActions.setLoading(false);
          this.setState(
            {
              searchValue: value,
              properties: this._propertyList,
            },
            () => {
              this.setSelectedProps(this.state.properties);
            }
          );
        })
        .catch(() => {
          loadingActions.setLoading(false);
        });
    } else {
      this.setState({ searchValue: value });
    }
  };

  private onSelect = (data: any) => {
    const selectedList = this.state.isSelected;
    const tabledata = this.state.tabledata;
    if (data.selected) {
      const i = selectedList?.findIndex(
        (x) => x.id === data.id && x.directionId === data.directionId
      );
      selectedList.splice(i, 1);
      const td = this.state.tabledata?.findIndex(
        (x) => x.id === data.id && x.directionId === data.directionId
      );
      if (td >= 0) tabledata.splice(td, 1);
      if(td == 0)
        {
          while (tabledata.length > 0) {
            tabledata.splice(0, 1); // Remove the first element repeatedly
          }
        }
    }
    this.setState(
      {
        isSelected: selectedList,
        tabledata,
      },
      () => {
        if (this.state.isSelected.includes(data.id)) {
          this.setState({ dataId: data.id });
          var array = [...this.state.isSelected]; // make a separate copy of the array
          var index = array.indexOf(data.id);
          if (index !== -1) {            
            array.splice(index, 1);
            this.state.tabledata.forEach((f: any) => {
              array.forEach((a: any) => {
                if (
                  `${f.propertyId}-${f.directionId}` ===
                  `${a.id}-${a.directionId}`
                ) {
                  this._unselected.push({
                    name: f.name,
                    minValue: f.minValue,
                    maxValue: f.maxValue,
                    average: f.average,
                    unit: f.unit,
                    deviation: f.deviation,
                    propertyId: f.propertyId,
                    data: f.data,
                    color: f.color,
                    directionId: f.directionId,
                  });
                }
              });
              console.log("print unselect");
              console.log(this._unselected);
              this.setState({
                isSelected: array,
                tabledata: this._unselected,
              });
            });
            this._directions = this._unselected;
            this._unselected = [];
            this.setSelectedProps(this.state.properties);
          }
        } else {
          if (this.state.isSelected.length <= 3) {
            if (!data.selected) {
              this.state.isSelected.push(data);
            }
            loadingActions.setLoading(true);
            this.propertyValues(data);
            this.setSelectedProps(this.state.properties);

          } else {
            triggerNotifications.error(
              i18next.t("Only Four Properties can be selected")
            );
          }
        }
      }
    );
  };

  private setSelectedProps = (selectedProps: any[]) => {
    selectedProps.forEach((element) => {
      element.selected = this.state.isSelected.some(
        (d: any) => d.id === element.id && d.directionId === element.directionId
      );
    });
    this.setState({
      properties: selectedProps,
    });
  };

  private setTrendCustomFromDate = (val: any) => {
    this.setState({
      selectFromDate: moment(val._d).format(this._datetimeFormat),
    });
  };
  private setTrendCustomToDate = (val: any) => {
    this.setState({
      selectToDate: moment(val._d).format(this._datetimeFormat),
    });
  };

  private onRefresh = () => {
    this.propertyValues(this.state.isSelected);
  };
  private getRandomColor = () => {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };
  private clearAllFilters = () => {
    this.reSet();
    this.setState(
      {
        selectedDateRange: [CONSTANTS.DATE_RANGES[0]],
      },
      () => {
        this.onDateRangeChange([CONSTANTS.DATE_RANGES[0]]);
      }
    );
  };

  public render() {    
    
    return (
      <Translation>
        {(t) => (
          <div>
            <React.Fragment>
              <SidebarLayout
                isFullSidebarVisible={this.state.isFullSidebarVisible}
                isShowSelectFilter={true}
                isShowTrends={true}
                handlePanelToggle={() =>
                  this.setState({
                    isFullSidebarVisible: !this.state.isFullSidebarVisible,
                  })
                }
                selectedDateRange={this.state.selectedDateRange}
                dateRangeChangeHandler={this.onDateRangeChange}
                selectFromDate={this.state.selectFromDate}
                selectToDate={this.state.selectToDate}
                daterange={CONSTANTS.DATE_RANGES}
                setTrendCustomFromDate={this.setTrendCustomFromDate}
                setTrendCustomToDate={this.setTrendCustomToDate}
                selectedGrade={this.state.selectedGrade}
                GradeChangeHandler={this.GradeChangeHandler}
                trendDropdownGradeList={
                  this.state.selectedSource[0].value !==
                  this._defaultDrpOption[0]?.value
                    ? this.state.selectedSample[0].value !==
                      this._defaultDrpOption[0]?.value
                      ? this.state.gradeList?.filter(({ id }) =>
                          this.state.sampleList
                            ?.filter(({ sourceId }) =>
                              this.state.selectedSource.some(
                                (source) => source.value === sourceId
                              )
                            )
                            ?.filter(({ id }) =>
                              this.state.selectedSample.some(
                                (sample) => sample.value === id
                              )
                            )
                            .some(
                              (sample) =>
                                (sample?.gradeId
                                  ? sample?.gradeId
                                  : sample?.product?.grade?.id) === id
                            )
                        )
                      : this.state.gradeList?.filter(({ id }) =>
                          this.state.sampleList
                            ?.filter(({ sourceId }) =>
                              this.state.selectedSource.some(
                                (source) => source.value === sourceId
                              )
                            )
                            .some(
                              (sample) =>
                                (sample?.gradeId
                                  ? sample?.gradeId
                                  : sample?.product?.grade?.id) === id
                            )
                        )
                    : this.state.selectedSample[0].value !==
                      this._defaultDrpOption[0]?.value
                    ? this.state.gradeList?.filter(({ id }) =>
                        this.state.sampleList
                          ?.filter(({ id }) =>
                            this.state.selectedSample.some(
                              (sample) => sample.value === id
                            )
                          )
                          .some(
                            (sample) =>
                              (sample?.gradeId
                                ? sample?.gradeId
                                : sample?.product?.grade?.id) === id
                          )
                      )
                    : this.state.gradeList?.filter(({ id }) =>
                        this.state.sampleList.some(
                          (sample) =>
                            (sample?.gradeId
                              ? sample?.gradeId
                              : sample?.product?.grade?.id) === id
                        )
                      )
                }
                selectedProduct={this.state.selectedProduct}
                ProductChangeHandler={this.ProductChangeHandler}
                trendDropdownProductList={
                  this.state.selectedSource[0].value !==
                  this._defaultDrpOption[0]?.value
                    ? this.state.selectedGrade[0]?.value ===
                      this._defaultDrpOption[0]?.value
                      ? this.state.selectedSample[0]?.value !==
                        this._defaultDrpOption[0]?.value
                        ? this.state.productList?.filter(({ id }) =>
                            this.state.sampleList
                              ?.filter(({ sourceId }) =>
                                this.state.selectedSource.some(
                                  (source) => source.value === sourceId
                                )
                              )
                              ?.filter(({ id }) =>
                                this.state.selectedSample.some(
                                  (sample) => sample.value === id
                                )
                              )
                              .some((sample) => sample?.productId === id)
                          )
                        : this.state.productList?.filter(({ id }) =>
                            this.state.sampleList
                              ?.filter(({ sourceId }) =>
                                this.state.selectedSource.some(
                                  (source) => source.value === sourceId
                                )
                              )
                              .some((sample) => sample?.productId === id)
                          )
                      : this.state.selectedSample[0]?.value !==
                        this._defaultDrpOption[0]?.value
                      ? this.state.productList?.filter(({ id }) =>
                          this.state.sampleList
                            ?.filter(({ sourceId }) =>
                              this.state.selectedSource.some(
                                (source) => source.value === sourceId
                              )
                            )
                            ?.filter(({ id }) =>
                              this.state.selectedSample.some(
                                (sample) => sample.value === id
                              )
                            )
                            ?.filter(({ gradeId }) =>
                              this.state.selectedGrade.some(
                                (grade) => grade.value === gradeId
                              )
                            )
                            .some((sample) => sample?.productId === id)
                        )
                      : this.state.productList?.filter(({ id }) =>
                          this.state.sampleList
                            ?.filter(({ sourceId }) =>
                              this.state.selectedSource.some(
                                (source) => source.value === sourceId
                              )
                            )
                            ?.filter(({ gradeId }) =>
                              this.state.selectedGrade.some(
                                (grade) => grade.value === gradeId
                              )
                            )
                            .some((sample) => sample?.productId === id)
                        )
                    : this.state.selectedGrade[0]?.value ===
                      this._defaultDrpOption[0]?.value
                    ? this.state.selectedSample[0]?.value !==
                      this._defaultDrpOption[0]?.value
                      ? this.state.productList?.filter(({ id }) =>
                          this.state.sampleList
                            ?.filter(({ id }) =>
                              this.state.selectedSample.some(
                                (sample) => sample.value === id
                              )
                            )
                            .some((sample) => sample?.productId === id)
                        )
                      : this.state.productList?.filter(({ id }) =>
                          this.state.sampleList.some(
                            (sample) => sample?.productId === id
                          )
                        )
                    : this.state.selectedSample[0]?.value !==
                      this._defaultDrpOption[0]?.value
                    ? this.state.productList?.filter(({ id }) =>
                        this.state.sampleList
                          ?.filter(({ id }) =>
                            this.state.selectedSample.some(
                              (sample) => sample.value === id
                            )
                          )
                          ?.filter(({ gradeId }) =>
                            this.state.selectedGrade.some(
                              (grade) => grade.value === gradeId
                            )
                          )
                          .some((sample) => sample?.productId === id)
                      )
                    : this.state.productList?.filter(({ id }) =>
                        this.state.sampleList
                          ?.filter(({ gradeId }) =>
                            this.state.selectedGrade.some(
                              (grade) => grade.value === gradeId
                            )
                          )
                          .some((sample) => sample?.productId === id)
                      )
                }
                selectedSample={this.state.selectedSample}
                SampleChangeHandler={this.SampleChangeHandler}
                selectedSource={this.state.selectedSource}
                trendDropdownSourceList={this.state.sourceDropdownList}
                SourceChangeHandler={this.SourceChangeHandler}
                //GRADE ID
                trendDropdownSampleList={
                  this.state.selectedSource[0].value !==
                  this._defaultDrpOption[0]?.value
                    ? this.state.selectedGrade[0]?.value ===
                      this._defaultDrpOption[0]?.value
                      ? this.state.selectedProduct[0]?.value ===
                        this._defaultDrpOption[0]?.value
                        ? this.state.sampleList?.filter(({ sourceId }) =>
                            this.state.selectedSource.some(
                              (source) => source.value === sourceId
                            )
                          )
                        : this.state.sampleList
                          ?.filter(({ sourceId }) =>
                            this.state.selectedSource.some(
                              (source) => source.value === sourceId
                            )
                          )
                          ?.filter(({ productId }) =>
                              this.state.selectedProduct.some(
                                (product) => product.value === productId
                              )
                            )
                      : this.state.selectedProduct[0]?.value ===
                        this._defaultDrpOption[0]?.value
                      ? this.state.sampleList
                          ?.filter(({ sourceId }) =>
                            this.state.selectedSource.some(
                              (source) => source.value === sourceId
                            )
                          )
                          ?.filter(({ gradeId }) =>
                            this.state.selectedGrade.some(
                              (grade) => grade.value === gradeId
                            )
                          )
                      : this.state.sampleList
                          ?.filter(({ sourceId }) =>
                            this.state.selectedSource.some(
                              (source) => source.value === sourceId
                            )
                          )
                          ?.filter(({ gradeId }) =>
                            this.state.selectedGrade.some(
                              (grade) => grade.value === gradeId
                            )
                          )
                          ?.filter(({ productId }) =>
                            this.state.selectedProduct.some(
                              (product) => product.value === productId
                            )
                          )
                    : this.state.selectedGrade[0]?.value ===
                      this._defaultDrpOption[0]?.value
                    ? this.state.selectedProduct[0]?.value ===
                      this._defaultDrpOption[0]?.value
                      ? this.state.sampleList
                      : this.state.sampleList?.filter(({ productId }) =>
                          this.state.selectedProduct.some(
                            (product) => product.value === productId
                          )
                        )
                    : this.state.selectedProduct[0]?.value ===
                      this._defaultDrpOption[0]?.value
                    ? this.state.sampleList?.filter(({ gradeId }) =>
                        this.state.selectedGrade.some(
                          (grade) => grade.value === gradeId
                        )
                      )
                    : this.state.sampleList
                        ?.filter(({ gradeId }) =>
                          this.state.selectedGrade.some(
                            (grade) => grade.value === gradeId
                          )
                        )
                        ?.filter(({ productId }) =>
                          this.state.selectedProduct.some(
                            (product) => product.value === productId
                          )
                        )
                }
                clearAllFilters={this.clearAllFilters}
                loadingProperties={this.state.loadingProperties}
              >
                <SidebarTitle
                  title={t(CONSTANTS.MODULE_PROPERTY)}
                  selectedCount={this.state.isSelected.length}
                />
                <div className="px-2 text-center">
                  <Input
                    type="discreet"
                    dataType="text"
                    placeholder={t(CONSTANTS.LABEL_SEARCH)}
                    icon="abb/search"
                    value={this.state.searchValue}
                    onValueChange={this.onsearch}
                  />

                  <div className="page-scroll-trend">
                    {this.state.properties
                      ?.sort((a, b) => b.selected - a.selected)
                      ?.map((i) => (
                        <div className="row" key={`${i.id} - ${i.directionId} - ${i.code}`}>
                          <div
                            className="ml-3"
                            style={{ width: "20%", borderRadius: "5px" }}
                          >
                            <WithTooltip>
                              <Checkbox
                                sizeClass="small"
                                label={i.name}
                                value={i.selected === true}
                                onChange={this.onSelect}
                                data={i}
                                key={`${i.id} - ${i.directionId}`}
                              />
                              <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                                <p>{i?.name}</p>
                              </Tooltip>
                            </WithTooltip>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </SidebarLayout>

              <div
                className={
                  this.state.isFullSidebarVisible
                    ? "main-layout ml-3 no-padding main-layout-trends"
                    : "main-full-layout float-right main-full-layout-trends"
                }
              >
                <Landing
                  items={this.state.data}
                  tableItems={this.state.tabledata}
                  properties={this.state.propertiesValues}
                  isSelected={this.state.isSelected}
                  dataId={this.state.dataId}
                  onRefresh={this.onRefresh}
                  selectedDateRange={this.state.selectedDateRange}
                  thresholdSettings={this.state.thresholdSettings}
                  start={this.state.selectFromDate}
                  end={this.state.selectToDate}
                  isLoading={this.state.isLoading}
                  selectedGrades={this.state.selectedGrade}
                  selectedProducts={this.state.selectedProduct}
                  selectedSamples={this.state.selectedSample}
                  selectedSources={this.state.selectedSource}
                />
              </div>
            </React.Fragment>
          </div>
        )}
      </Translation>
    );
  }
}
